import * as React from 'react';
import { ListEditorDefaultDeletor } from './ListEditorDefaultDeletor';
import { ListEditorDefaultEditor } from './ListEditorDefaultEditor';
import { ListEditorDefaultList } from './ListEditorDefaultList';
import { useListEditor } from './useListEditor';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Use to orchestrate crud on  arrays using render props and providing basic defaults for list edit create
 */
export function ListEditor(_ref) {
  let {
    data,
    updateFn,
    showCreateComponent,
    onCreateDismiss,
    renderListComponent = ListEditorDefaultList,
    renderDeleteComponent = ListEditorDefaultDeletor,
    renderEditComponent = ListEditorDefaultEditor,
    renderCreateComponent = ListEditorDefaultEditor
  } = _ref;
  const {
    onDeleteSelect,
    onDeleteAction,
    onDeleteDismiss,
    deleteIndex,
    onEditSelect,
    onItemUpdated,
    editIndex,
    onEditDismiss,
    onItemCreated,
    onAddDismiss,
    addIsVisible
  } = useListEditor({
    data: data,
    updateFn: updateFn,
    showCreateComponent: showCreateComponent,
    onCreateDismiss: onCreateDismiss
  });
  const List = React.useCallback(() => {
    return renderListComponent({
      data: data,
      onDeleteSelect: onDeleteSelect,
      onEditSelect: onEditSelect
    });
  }, [data]);
  const Delete = () => {
    return renderDeleteComponent({
      data: data[deleteIndex],
      onDismiss: onDeleteDismiss,
      onSuccess: onDeleteAction
    });
  };
  const Edit = React.useCallback(() => {
    return renderEditComponent({
      data: data[editIndex],
      onDismiss: onEditDismiss,
      onSuccess: onItemUpdated
    });
  }, [editIndex]);
  const Create = () => {
    return renderCreateComponent({
      onDismiss: onAddDismiss,
      onSuccess: onItemCreated
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [data && /*#__PURE__*/_jsx(List, {}), deleteIndex > -1 && /*#__PURE__*/_jsx(Delete, {}), editIndex > -1 && /*#__PURE__*/_jsx(Edit, {}), addIsVisible && /*#__PURE__*/_jsx(Create, {})]
  });
}